import Button from "../../../../components/UI/Button";

const SizeListActions = ({clickHandler}) => {
  return (
    <Button
      text="+ Add New Size"
      variant={"btn_black"}
      onClickHandler={clickHandler}
    />
  );
}

export default SizeListActions;